import { connect } from 'react-redux'
import MessageTemplates from '../components/message-templates'

const mapStateToProps = state => ({...state.messageTemplates})

const mapDispatchToProps = dispatch => ({
  createTemplate: payload => dispatch({type: 'MESSAGE_TEMPLATES.CREATE_TEMPLATE', payload}),
  updateTemplate: payload => dispatch({type: 'MESSAGE_TEMPLATES.UPDATE_TEMPLATE', payload}),
  deleteTemplate: payload => dispatch({type: 'MESSAGE_TEMPLATES.DELETE_TEMPLATE', payload}),
})

export default connect(mapStateToProps, mapDispatchToProps)(MessageTemplates)
